<template>
  <div>
    <div class="fund-filter-tabs">
      <b-tabs content-class="mt-4">
        <b-tab title="Összes megjelenítése" @click="setSelectedTab('')" active></b-tab>
        <b-tab title="Hiteltermék" @click="setSelectedTab('CREDIT')"></b-tab>
        <b-tab title="Támogatás" @click="setSelectedTab('APPLICATION')"></b-tab>
        <b-tab title="Tőketermék" @click="setSelectedTab('CAPITAL_PRODUCT')"></b-tab>
        <b-tab v-if="showCombinedCompetitionTab" title="Kombinált termék" @click="setSelectedTab('COMBINED')"></b-tab>
      </b-tabs>
    </div>

    <FundMapResultsFilter class="d-none" @new-filters-selected="handleNewFilters"></FundMapResultsFilter>
    <div v-if="filteredCompetitions.length > 0">
      <div class="m-1 mt-3" v-for="(offer, index) in filteredCompetitions" :key="index">
        <fund-map-filtered-competitions :competition="offer" :serialNumber="index + 1" />
      </div>
    </div>
    <div
      class="no-funds-wrapper d-flex flex-column align-items-center flex-sm-row"
      v-if="filteredCompetitions.length === 0"
    >
      <div class="col-sm text-left">
        <h3 class="no-fund-header">A megadott adatok alapján sajnos nincsenek elérhető források.</h3>
        <p class="no-fund-desc">Kérjük, módosítson az adatokon és próbálja meg még egyszer!</p>
      </div>
      <img src="../../../assets/img/fundMap/no-funds.png" alt="no-funds" class="col-sm" />
    </div>
    <b-button class="btn ml-3 mt-2 link-button btn-primary" @click="prev" variant="secondary"> Vissza </b-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FundMapFilteredCompetitions from '../components/FundMapFilteredCompetitions.vue'
import FundMapResultsFilter from '../../../components/FundMapResultsFilter.vue'

export default {
  name: 'FundResults',
  data() {
    return {
      storeParams: {},
      competitionsFilters: { currency: null, maximumValue: '', minimumValue: '', interestRate: '' },
      selectedTab: ''
    }
  },
  computed: {
    ...mapGetters(['fundMapCompetitions', 'selectedFundMapCategory']),
    showCombinedCompetitionTab() {
      return this.fundMapCompetitions.find(competition => competition.type === 'COMBINED')
    },
    filteredCompetitions() {
      return this.fundMapCompetitions.filter(competition => {
        if (this.competitionsFilters.currency && competition.currency !== this.competitionsFilters.currency) {
          return false
        }
        if (this.selectedTab && this.selectedTab !== competition.type) {
          return false
        }
        // if (this.competitionsFilters.maximumValue && competition.value > this.competitionsFilters.maximumValue) {
        //   return false
        // }
        // if (this.competitionsFilters.minimumValue && competition.value < this.competitionsFilters.minimumValue) {
        //   return false
        // }
        // if (this.competitionsFilters.position && competition.position !== this.competitionsFilters.position) {
        //   return false
        // }
        return true
      })
    }
  },
  components: {
    FundMapFilteredCompetitions,
    FundMapResultsFilter
  },
  methods: {
    scrollToTop() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    },
    prev() {
      if (!this.selectedFundMapCategory) {
        this.scrollToTop()
        return this.$store.dispatch('resetStepsAction')
      }
      this.scrollToTop()
      this.$store.dispatch('prevStepAction')
    },
    handleNewFilters(filters) {
      this.competitionsFilters = filters
    },
    setSelectedTab(tab) {
      this.selectedTab = tab
    }
  },
  created() {
    this.$store.dispatch('getUserCompanies', {})
  }
}
</script>

<style scoped>
.login-box {
  max-width: 800px;
  margin: 0 auto;
  border-radius: 8px;
}
.regisration-button {
  text-decoration: underline;
  color: green;
  cursor: pointer;
}

.no-funds-wrapper {
  margin-top: 32px;
  margin-bottom: 64px;
  padding: 24px 16px;
  background-color: #f7fbfc;
  border-radius: 8px;
}

.no-fund-header {
  color: #00903c;
  font-weight: 400;
  font-size: 24px;
}

.no-fund-desc {
  color: #636e72;
  font-weight: 500;
  font-size: 16px;
}
.btn-primary {
  min-width: 150px;
  float: left;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .no-funds-wrapper {
    padding: 24px 36px;
  }
}
@media screen and (min-width: 1200px) {
  .no-funds-wrapper {
    padding: 24px 72px;
  }

  .no-fund-header {
    font-size: 32px;
  }
}
</style>
<style lang="scss">
.fund-filter-tabs {
  .nav-tabs {
    border-bottom: unset;
  }
  .nav-link {
    border: unset;
    color: #2d3436;
    border-bottom: 2px solid #dfe2ea;
    margin-bottom: 1px;
    &:hover {
      color: #2d3436;
    }
  }
  .nav-link.active {
    border-bottom: 2px solid #00903c;
  }
}

.nav-tabs {
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: visible;
}
@media (max-width: 768px) {
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
